import Menu from './menu.js';
import Header from './header.js';
import Modal from './modal.js';
import Form from './form.js';


function onDocumentLoadedCustom() {
  window.removeEventListener('load', onDocumentLoadedCustom);
  const header = new Header();
  const menu = new Menu();
  const modal = new Modal();
  const form = new Form();
}


window.addEventListener('load', onDocumentLoadedCustom);